import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "custom-map",
    ref: "customMapEl",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onMapClick && _ctx.onMapClick(...args))),
    onTouchend: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onMapClick && _ctx.onMapClick(...args)))
  }, null, 544))
}